function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  pickBy
} = require('lodash');
const {
  evaluateSource
} = require('../lib/evaluateSource');

/**
  * @function evalute - evaluate formOptionsBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const sourceEvaluator = source2 => evaluateSource(source2, content, parentContentPath, transientContext, nativeFunctions);
  const formTypeIdentifiers = await sourceEvaluator(source.formTypeIdentifiers);
  if (formTypeIdentifiers === undefined) {
    return undefined;
  }
  const filters = await sourceEvaluator(source.filters);
  const hasChildren = await sourceEvaluator(source.hasChildren);
  const sort = (await sourceEvaluator(source.sort)) || [{
    index: 'title',
    ascending: true
  }];
  const indexes = (await sourceEvaluator(source.indexes)) || [];
  const querySource = {
    type: 'queryFormBehavior',
    formTypeIdentifiers,
    indexes: ['title'].concat(indexes),
    sort,
    filters
  };
  const forms = await sourceEvaluator(querySource);
  if (forms === undefined) {
    return undefined;
  }
  const {
    paging: {
      offset = 0
    } = {}
  } = transientContext;
  const options = {};
  forms.forEach((form, index) => {
    const {
      id,
      map
    } = form;
    const {
      title
    } = map;
    const other = pickBy(map, (value, key) => indexes.includes(key));
    const value = _objectSpread(_objectSpread({}, other), {}, {
      title,
      _formRef: id,
      _created: offset + index + 1
    });
    if (hasChildren !== undefined) {
      value.hasChildren = hasChildren;
    }
    options[id] = value;
  });
  return {
    options,
    keep: ['_formRef']
  };
};
module.exports = {
  evaluate
};